module.exports = __webpack_public_path__ + "img/user-videoNew2.38f5e1ed.png";